import { render } from "./CampusCentralSettingsPage.vue?vue&type=template&id=a435b984&scoped=true"
import script from "./CampusCentralSettingsPage.vue?vue&type=script&lang=js"
export * from "./CampusCentralSettingsPage.vue?vue&type=script&lang=js"

import "./CampusCentralSettingsPage.vue?vue&type=style&index=0&id=a435b984&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a435b984"],['__file',"src/views/CampusCentralSettingsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a435b984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a435b984', __exports__)) {
    api.reload('a435b984', __exports__)
  }
  
  module.hot.accept("./CampusCentralSettingsPage.vue?vue&type=template&id=a435b984&scoped=true", () => {
    api.rerender('a435b984', render)
  })

}


export default __exports__